import { VeiculoModel } from "@/models/cadastros/assistencia/veiculo/VeiculoModel";
import LocalidadeModel from "@/models/geolocalizacao/LocalidadeModel";
import { QuestionarioModel } from "@/models/cadastros/assistencia/QuestionarioModel";
import { MotivoServicoModel } from '@/models/cadastros/assistencia/guincho/MotivoServicoModel';
import { ParteDanificada } from '@/models/cadastros/assistencia/guincho/ParteDanificada';
import { ArquivoAnexoModel } from '@/models/cadastros/assistencia/guincho/ArquivoAnexoModel';
import ServicoSubClienteModel  from '@/models/cadastros/assistencia/ServicoSubClienteModel';
import { TipoLocalRemocaoModel } from "@/models/cadastros/assistencia/TipoLocalRemocaoModel";
import ClienteAdministrativoModel from "@/models/cadastros/assistencia/ClienteAdministrativoModel";

export class QuestionarioGuinchoModel implements QuestionarioModel {
  idServico?: number;
  veiculoPertenceAoAssociado: boolean;
  associadoNoLocal?: boolean;
  nomeContatoNoLocal?: string;
  telefoneContatoNoLocal?: string;
  motivoSolicitacao: MotivoServicoModel;
  parteDanificada?: ParteDanificada;
  descricaoParteDanificada?: string;
  rodaTravada?: boolean;
  veiculo: VeiculoModel;
  localizacao: LocalidadeModel;
  destino: LocalidadeModel;
  fotos?: ArquivoAnexoModel[];
  servicoSubCliente?: ServicoSubClienteModel;
  tipoLocalRemocao?: TipoLocalRemocaoModel;
  liberadoRemocao?: boolean;
  veiculoEletrico?: boolean;
  veiculoBlindado?: boolean;
  veiculoCarregado?: boolean;
  clienteAdministrativo?: ClienteAdministrativoModel;
  idPrestador?: number;
  constructor(
    veiculoPertenceAoAssociado: boolean,
    motivoSolicitacao: MotivoServicoModel,
    veiculo: VeiculoModel,
    localizacao: LocalidadeModel,
    destino: LocalidadeModel,
    associadoNoLocal?: boolean,
    nomeContatoNoLocal?: string,
    telefoneContatoNoLocal?: string,
    parteDanificada?: ParteDanificada,
    descricaoParteDanificada?: string,
    rodaTravada?: boolean,
    fotos?: ArquivoAnexoModel[],
    servicoSubCliente?: ServicoSubClienteModel,
    tipoLocalRemocao?: TipoLocalRemocaoModel,
    liberadoRemocao?: boolean,
    veiculoEletrico?: boolean,
    veiculoBlindado?: boolean,
    veiculoCarregado?: boolean,
    clienteAdministrativo?: ClienteAdministrativoModel,
    idPrestador?: number,
  ) {
    this.veiculoPertenceAoAssociado = veiculoPertenceAoAssociado;
    this.associadoNoLocal = associadoNoLocal;
    this.motivoSolicitacao = motivoSolicitacao;
    this.veiculo = veiculo;
    this.localizacao = localizacao;
    this.destino = destino;
    this.nomeContatoNoLocal = nomeContatoNoLocal;
    this.telefoneContatoNoLocal = telefoneContatoNoLocal;
    this.parteDanificada = parteDanificada;
    this.descricaoParteDanificada = descricaoParteDanificada;
    this.rodaTravada = rodaTravada;
    this.fotos = fotos;
    this.servicoSubCliente = servicoSubCliente;
    this.tipoLocalRemocao = tipoLocalRemocao;
    this.liberadoRemocao = liberadoRemocao;
    this.veiculoEletrico = veiculoEletrico;
    this.veiculoBlindado = veiculoBlindado;
    this.veiculoCarregado = veiculoCarregado;
    this.clienteAdministrativo = clienteAdministrativo;
    this.idPrestador = idPrestador;
  }
}
